/* eslint-disable */

import React, {
  ComponentType,
  useEffect,
  useRef,
  useState
} from 'react'
import uniqid from 'uniqid'
import hash from '@emotion/hash'
// import '../../../_sass/layout/_header.scss' // DO NOT REMOVE UNTIL FIXED
import './_header.scss' // HIS STYLE WILL NOT BE NEEDED

import { SFLogo } from '../SFLogo'
import { TopNavigationItem } from '../..'
import { SustainableFitchSiteHeaderMenu } from './SustainableFitchSiteHeaderMenu'

export type SustainableFitchSiteHeaderLinkProps = {
  className?: string
  label: string
  slug: string
}

export type SustainableFitchSiteHeaderProps = {
  navigation: TopNavigationItem[]
  renderLink?: ComponentType<SustainableFitchSiteHeaderLinkProps>
  hasLanguageToggle?: boolean
  isOverlayOpen: boolean
  toggleOverlayClick: () => void
  languageSlug?: string
  toggleLanguage: (selectedLang: string) => void
  closeOverlay: () => void
  loginLink: string
}

const languagesToDisplay = [
  {
    languageCode: 'en',
    language: 'English'
  },
  {
    languageCode: 'zh-cn',
    language: '中文简体'
  },
  {
    languageCode: 'ja',
    language: '日本語'
  }
]

export type SustainableFitchSiteHeaderRenderLinkProps =
  Partial<SustainableFitchSiteHeaderLinkProps>

const NavLink = (
  { className = '',
    slug,
    label }: SustainableFitchSiteHeaderRenderLinkProps
) => (
  <a className={className} href={slug} aria-label={label}>
    {label}
  </a>
)

export const SustainableFitchSiteHeader = ({
  navigation,
  hasLanguageToggle,
  isOverlayOpen,
  toggleLanguage,
  toggleOverlayClick,
  languageSlug,
  closeOverlay,
  loginLink
}: SustainableFitchSiteHeaderProps) => {
  const [isActiveMenu, setActiveMenu] = useState('default')
  const [isExpanded, setExpanded] = useState(false)
  const [langDisplay, setlangDisplay] = useState('English')

  // eslint-disable-next-line
  const [isActiveNav, setActiveNav] = useState('js-nav-toggle')
  const [isActivePopup, setActivePopup] = useState('')
  const navToggle = isActiveNav
  const navPopup = isActivePopup

  const wrapperRef = useRef(null)
  const isBrowser = typeof window !== 'undefined' && window
  const location = isBrowser ? window.location.href : '/'
  const lastChart = location.lastIndexOf('/')
  languageSlug =
    isBrowser && window.location.pathname === '/'
      ? 'en'
      : location.substring(lastChart + 1)
  let languageToggleDisplay = false

  languagesToDisplay.map((lang) => {
    if (lang.languageCode === languageSlug) {
      languageToggleDisplay = true
    }
  })

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | KeyboardEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setActiveMenu('default')
      }
      if (
        event.target.className !== 'language__row' &&
        event.target.className !== 'language_label' &&
        event.target.className !== ''
      ) {
        setExpanded(false)
      }
    }

    const langObj = languagesToDisplay.find((value) => {
      return value.languageCode === languageSlug
    })
    setlangDisplay(langObj ? langObj?.language : 'English')
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])

  const toggleMenu = (menu: string) => {
    setActiveMenu(menu === isActiveMenu ? '' : menu)
  }

  const handleClick = () => {
    if (navToggle === 'js-nav-toggle') {
      setActiveNav('js-nav-toggle nav--active')
      setActivePopup('active')
    } else {
      setActiveNav('js-nav-toggle')
      setActivePopup('')
    }
  }

  const openDropdown = () => {
    setExpanded(true)
  }

  const setlanguage = (languageCode: string) => {
    toggleLanguage(languageCode)
    closeOverlay()
  }

  const getLanguageToggle = () => {
    return hasLanguageToggle && languageToggleDisplay ? (
      <div className="region--language">
        <div
          className="overlay__language"
          onClick={openDropdown}
          onKeyUp={openDropdown}
          role="button"
          tabIndex={0}
        >
          {langDisplay}
          <i className="fas fa-globe-americas" />
        </div>
        <div
          id="language__overlay"
          role="radio"
          aria-checked="false"
          className={`${isExpanded && 'active'}`}
        >
          {languagesToDisplay.map((lang) => (
            <div
              key={hash(lang.languageCode)}
              className="language__row"
              role="button"
              onClick={() => {
                setlanguage(lang.languageCode)
              }}
              onKeyUp={() => {
                setlanguage(lang.languageCode)
              }}
              tabIndex={0}
            >
              <span>
                <input
                  checked={languageSlug === lang.languageCode}
                  type="radio"
                  value={lang.languageCode}
                />
                <span className="language_label">{lang.language}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    ) : (
      ''
    )
  }
  const handleSearchButtonClick = () => {
    toggleOverlayClick()
    setActiveMenu('')
  }

  return (
    <header className="header" ref={wrapperRef}>
      <div className="wrapper--1">
        <div className="region region--logo">
          <a onClick={() => closeOverlay()} href="/">
            <SFLogo />
          </a>
        </div>
        <div className="region region--nav">
          <div
            className={navToggle}
            data-testid="hamburger-button"
            onClick={() => handleClick()}
            onKeyUp={() => handleClick()}
            role="button"
            tabIndex={0}
          >
            <span className="nav-line nav-line--1" />
            <span className="nav-line nav-line--2" />
            <span className="nav-line nav-line--3" />
          </div>

          <nav
            role="navigation"
            className={navPopup}
            data-testid="hamburger-menu"
            id="block-sustainable-fitch-main-menu"
          >
            <ul className="menu menu-level--0">
              {navigation.map(({ label, menus }, navigationIndex) => {
                const currentMenu = `${navigationIndex}-${label}`

                let navigationHref
                if (menus.length < 2) {
                  navigationHref = menus[0]?.relatedLinkHref
                }
                return (
                  <li
                    className="navigation__group"
                    key={uniqid()}
                    role="presentation"
                    {...(!navigationHref && { 
                      "aria-expanded": isActiveMenu === currentMenu ? "true" : "false",
                      "aria-haspopup": "true" 
                    })}
                  >
                    <span
                      onClick={() => toggleMenu(currentMenu)}
                      onKeyUp={() => toggleMenu(currentMenu)}
                      role="presentation"
                    >
                      {' '}
                      {navigationHref ? <NavLink className='link-nav' label={label} slug={navigationHref} />
                        : label}
                    </span>
                    {!navigationHref && <ul
                      className="menu menu-level--1"
                      style={{
                        display: isActiveMenu === currentMenu ? 'block' : 'none'
                      }}
                    >
                      <SustainableFitchSiteHeaderMenu closeOverlayOnMenu={closeOverlay} menus={menus} />
                    </ul>}
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
        <div className="region region--user">
          {getLanguageToggle(hasLanguageToggle)}
          <div className="region--search">
            {isOverlayOpen ? (
              <span
                className="overlay__search"
                onClick={handleSearchButtonClick}
                onKeyUp={handleSearchButtonClick}
                role="button"
                tabIndex={0}
                data-testid="handleSearch"
              >
                Close <i className="fas fa-times" />
              </span>
            ) : (
              <span
                className="overlay__search"
                onClick={handleSearchButtonClick}
                onKeyUp={handleSearchButtonClick}
                role="button"
                tabIndex={0}
              >
                Search <i className="fas fa-search" />
              </span>
            )}
          </div>
          <div className="region--login">
            <a
              className="button button--login"
              href={loginLink}
              onClick={() => closeOverlay()}
              target="_blank"
            >
              Client Login
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default SustainableFitchSiteHeader
